<template>
  <v-main>
    <introNavigation />
    <v-container fluid fill-height>
      <v-row align-center justify-center>
        <v-flex xs12 sm12 md12>
        <v-col cols="12" md="6" class="mx-auto">
          <p class="display-1">{{ $t('confirmActiveKey.welcomeTo') }}</p>
          <p class="text-welcome">
            {{ $t('confirmActiveKey.onlineShop') }}
            <span class="font-weight-bold">CONASI365</span>
          </p>
          <p>{{ $t('intro.haveAccountPleaseLogin') }}</p>
          <div class="my-2">
            <v-btn color="primary" @click="onGoLogin">{{ $t('common.login') }}</v-btn>
          </div>
          <div class="my-12">
            <div class="d-flex justify-center align-center">
                <div style="width: 150px; height: 1px; background-color: #e5e5e5;"></div>
                <span class="mx-2">{{ $t('intro.or') }}</span>
                <div style="width: 150px; height: 1px; background-color: #e5e5e5;"></div>
            </div>
          </div>
          <div class="my-2">
            <v-btn color="primary" @click="onGoRegister">{{ $t('common.createAccount') }}</v-btn>
          </div>
        </v-col>
        </v-flex>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import IntroNavigation from "Components/IntroNavigation";
export default {
  components: {
    IntroNavigation,
  },
  methods: {
    /**
     * Login
     */
    onGoLogin: function () {
       this.$router.push({
           name: 'Login'
       })
    },
    /**
     * Register
     */
    onGoRegister: function () {
       this.$router.push({
           name: 'Register'
       })
    }
  }
};
</script>

<style lang="scss" scoped>
.text-welcome {
  color: #FE6D6D !important;
  font-size: 24px;
  font-weight: 600;
}
</style>
